import {
  CANCEL_PATH,
  CORRECT_PATH,
  DOT_LIST,
  SEARCH_PATH,
  TICK_PATH,
  RIGHT_ARROW,
  BACKGROUND_PATTERN,
  LOCK_PATH,
  LOADER_PATH,
} from "./path";

export const BRAND_NAME = "intelliante";

const SIZES = {
  XS: 16,
  SM: 32,
  MD: 64,
  LG: 96,
};

const prefixID = "e00";

// replace 32, 32 with your SVG viewbox
// e001 is the unicode point which represents this custom icon. Increment this value for other icons
// replace 'REACT_ICON...' with your single-path SVG
export const faTickIcon = {
  prefix: BRAND_NAME,
  iconName: "tick-icon",
  icon: [SIZES.XS, SIZES.XS, [], prefixID + 1, TICK_PATH],
};

export const faDotList = {
  prefix: BRAND_NAME,
  iconName: "dot-list",
  icon: [SIZES.SM, SIZES.SM, [], prefixID + 2, DOT_LIST],
};

export const faCorrectIcon = {
  prefix: BRAND_NAME,
  iconName: "correct-icon",
  icon: [SIZES.XS, SIZES.XS, [], prefixID + 3, CORRECT_PATH],
};

export const faCancelIcon = {
  prefix: BRAND_NAME,
  iconName: "cancel-icon",
  icon: [SIZES.SM, SIZES.SM, [], prefixID + 4, CANCEL_PATH],
};

export const faSearchIcon = {
  prefix: BRAND_NAME,
  iconName: "search-icon",
  icon: [SIZES.XS, SIZES.XS, [], prefixID + 5, SEARCH_PATH],
};

export const faRightArrowIcon = {
  prefix: BRAND_NAME,
  iconName: "right-arrow-icon",
  icon: [SIZES.SM, SIZES.SM, [], prefixID + 6, RIGHT_ARROW],
};

export const faBackgroundPatternIcon = {
  prefix: BRAND_NAME,
  iconName: "background-pattern",
  icon: [SIZES.SM, SIZES.SM, [], prefixID + 7, BACKGROUND_PATTERN],
};

export const faLockIcon = {
  prefix: BRAND_NAME,
  iconName: "lock-icon",
  icon: [SIZES.SM, SIZES.SM, [], prefixID + 8, LOCK_PATH],
};

export const UserIcon = ({ className }) => (
  <svg
    className={className}
    width="23"
    height="19"
    viewBox="0 0 23 19"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M21.5625 17.5019V15.6686C21.5619 14.8562 21.2915 14.067 20.7938 13.4249C20.296 12.7828 19.5991 12.3242 18.8125 12.1211"
      stroke="#778583"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M16.0651 17.5V15.6667C16.0651 14.6942 15.6788 13.7616 14.9912 13.0739C14.3035 12.3863 13.3709 12 12.3984 12H5.0651C4.09264 12 3.16001 12.3863 2.47238 13.0739C1.78475 13.7616 1.39844 14.6942 1.39844 15.6667V17.5"
      stroke="#778583"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M15.1484 1.12109C15.9372 1.32304 16.6362 1.78174 17.1354 2.42488C17.6347 3.06802 17.9056 3.85902 17.9056 4.67318C17.9056 5.48733 17.6347 6.27833 17.1354 6.92148C16.6362 7.56462 15.9372 8.02332 15.1484 8.22526"
      stroke="#778583"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M8.72917 8.33333C10.7542 8.33333 12.3958 6.69171 12.3958 4.66667C12.3958 2.64162 10.7542 1 8.72917 1C6.70412 1 5.0625 2.64162 5.0625 4.66667C5.0625 6.69171 6.70412 8.33333 8.72917 8.33333Z"
      stroke="#778583"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const LocationIcon = ({ className }) => (
  <svg
    className={className}
    width="18"
    height="22"
    viewBox="0 0 18 22"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M8.5625 12C10.2194 12 11.5625 10.6569 11.5625 9C11.5625 7.34315 10.2194 6 8.5625 6C6.90565 6 5.5625 7.34315 5.5625 9C5.5625 10.6569 6.90565 12 8.5625 12Z"
      stroke="#778583"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M8.5625 1C6.44077 1 4.40594 1.84285 2.90565 3.34315C1.40535 4.84344 0.5625 6.87827 0.5625 9C0.5625 10.892 0.9645 12.13 2.0625 13.5L8.5625 21L15.0625 13.5C16.1605 12.13 16.5625 10.892 16.5625 9C16.5625 6.87827 15.7196 4.84344 14.2194 3.34315C12.7191 1.84285 10.6842 1 8.5625 1V1Z"
      stroke="#778583"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const DeleteIcon = ({ className }) => (
  <svg
    className={className}
    width="25"
    height="24"
    viewBox="0 0 25 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M6.07812 8.82422L18.1021 8.82422"
      stroke="#B8C1BF"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M10.8867 10.9414L10.8867 15.1767"
      stroke="#B8C1BF"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M13.293 10.9414L13.293 15.1767"
      stroke="#B8C1BF"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M6.875 8.82031L7.61934 16.6859C7.61934 17.0336 7.77618 17.367 8.05537 17.6128C8.33455 17.8587 8.7132 17.9968 9.10802 17.9968H15.0628C15.4576 17.9968 15.8362 17.8587 16.1154 17.6128C16.3946 17.367 16.5514 17.0336 16.5514 16.6859L17.2958 8.82031"
      stroke="#B8C1BF"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M10.0898 8.82353L10.0898 6.70588C10.0898 6.51867 10.1602 6.33913 10.2855 6.20675C10.4108 6.07437 10.5807 6 10.7578 6L13.4298 6C13.607 6 13.7769 6.07437 13.9022 6.20675C14.0275 6.33913 14.0978 6.51867 14.0978 6.70588L14.0978 8.82353"
      stroke="#B8C1BF"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <rect
      x="23.6133"
      y="0.5"
      width="23"
      height="23.0479"
      rx="3.5"
      transform="rotate(90 23.6133 0.5)"
      stroke="#778583"
    />
  </svg>
);

export const EditIcon = ({ className }) => (
  <svg
    className={className}
    width="25"
    height="24"
    viewBox="0 0 25 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M13.6602 7.63672L16.3929 10.364"
      stroke="#B8C1BF"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M6.01172 18H9.14941L17.3859 9.77998C17.8019 9.36472 18.0357 8.80152 18.0357 8.21426C18.0357 7.627 17.8019 7.0638 17.3859 6.64854C16.9698 6.23329 16.4054 6 15.817 6C15.2286 6 14.6642 6.23329 14.2482 6.64854L6.01172 14.8686V18Z"
      stroke="#B8C1BF"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <rect
      x="23.5469"
      y="0.5"
      width="23"
      height="23.048"
      rx="3.5"
      transform="rotate(90 23.5469 0.5)"
      stroke="#778583"
    />
  </svg>
);

export const AddIcon = ({ className }) => (
  <svg
    className={className}
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M9 7V0H7V7H0V9H7V16H9V9H16V7H9Z" fill="#EEF4F3" />
  </svg>
);


export const ApplicantIcon = ({ className }) => (
  <svg
    className={className}
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M9 7V0H7V7H0V9H7V16H9V9H16V7H9Z" fill="#EEF4F3" />
  </svg>
);


export const EmployerIcon = ({ className }) => (
  <svg
    className={className}
    width="15"
    height="20"
    viewBox="0 0 15 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M3.3 5.4C3.5387 5.4 3.76761 5.30518 3.9364 5.1364C4.10518 4.96761 4.2 4.73869 4.2 4.5C4.2 4.2613 4.10518 4.03239 3.9364 3.8636C3.76761 3.69482 3.5387 3.6 3.3 3.6C3.06131 3.6 2.83239 3.69482 2.6636 3.8636C2.49482 4.03239 2.4 4.2613 2.4 4.5C2.4 4.73869 2.49482 4.96761 2.6636 5.1364C2.83239 5.30518 3.06131 5.4 3.3 5.4ZM4.2 8.1C4.2 8.33869 4.10518 8.56761 3.9364 8.73639C3.76761 8.90518 3.5387 9 3.3 9C3.06131 9 2.83239 8.90518 2.6636 8.73639C2.49482 8.56761 2.4 8.33869 2.4 8.1C2.4 7.8613 2.49482 7.63239 2.6636 7.4636C2.83239 7.29482 3.06131 7.2 3.3 7.2C3.5387 7.2 3.76761 7.29482 3.9364 7.4636C4.10518 7.63239 4.2 7.8613 4.2 8.1ZM3.3 12.6C3.41819 12.6 3.53522 12.5767 3.64442 12.5315C3.75361 12.4863 3.85282 12.42 3.9364 12.3364C4.01997 12.2528 4.08626 12.1536 4.13149 12.0444C4.17672 11.9352 4.2 11.8182 4.2 11.7C4.2 11.5818 4.17672 11.4648 4.13149 11.3556C4.08626 11.2464 4.01997 11.1472 3.9364 11.0636C3.85282 10.98 3.75361 10.9137 3.64442 10.8685C3.53522 10.8233 3.41819 10.8 3.3 10.8C3.06131 10.8 2.83239 10.8948 2.6636 11.0636C2.49482 11.2324 2.4 11.4613 2.4 11.7C2.4 11.9387 2.49482 12.1676 2.6636 12.3364C2.83239 12.5052 3.06131 12.6 3.3 12.6ZM7.8 4.5C7.8 4.73869 7.70518 4.96761 7.5364 5.1364C7.36761 5.30518 7.13869 5.4 6.9 5.4C6.66131 5.4 6.43239 5.30518 6.2636 5.1364C6.09482 4.96761 6 4.73869 6 4.5C6 4.2613 6.09482 4.03239 6.2636 3.8636C6.43239 3.69482 6.66131 3.6 6.9 3.6C7.13869 3.6 7.36761 3.69482 7.5364 3.8636C7.70518 4.03239 7.8 4.2613 7.8 4.5ZM6.9 9C7.13869 9 7.36761 8.90518 7.5364 8.73639C7.70518 8.56761 7.8 8.33869 7.8 8.1C7.8 7.8613 7.70518 7.63239 7.5364 7.4636C7.36761 7.29482 7.13869 7.2 6.9 7.2C6.66131 7.2 6.43239 7.29482 6.2636 7.4636C6.09482 7.63239 6 7.8613 6 8.1C6 8.33869 6.09482 8.56761 6.2636 8.73639C6.43239 8.90518 6.66131 9 6.9 9ZM7.8 11.7C7.8 11.9387 7.70518 12.1676 7.5364 12.3364C7.36761 12.5052 7.13869 12.6 6.9 12.6C6.66131 12.6 6.43239 12.5052 6.2636 12.3364C6.09482 12.1676 6 11.9387 6 11.7C6 11.4613 6.09482 11.2324 6.2636 11.0636C6.43239 10.8948 6.66131 10.8 6.9 10.8C7.13869 10.8 7.36761 10.8948 7.5364 11.0636C7.70518 11.2324 7.8 11.4613 7.8 11.7ZM10.5 12.6C10.6182 12.6 10.7352 12.5767 10.8444 12.5315C10.9536 12.4863 11.0528 12.42 11.1364 12.3364C11.22 12.2528 11.2863 12.1536 11.3315 12.0444C11.3767 11.9352 11.4 11.8182 11.4 11.7C11.4 11.5818 11.3767 11.4648 11.3315 11.3556C11.2863 11.2464 11.22 11.1472 11.1364 11.0636C11.0528 10.98 10.9536 10.9137 10.8444 10.8685C10.7352 10.8233 10.6182 10.8 10.5 10.8C10.2613 10.8 10.0324 10.8948 9.8636 11.0636C9.69482 11.2324 9.6 11.4613 9.6 11.7C9.6 11.9387 9.69482 12.1676 9.8636 12.3364C10.0324 12.5052 10.2613 12.6 10.5 12.6ZM0.6 19.2C0.44087 19.2 0.288258 19.1368 0.175736 19.0243C0.0632142 18.9117 0 18.7591 0 18.6V1.8C0 1.32261 0.189642 0.864773 0.527208 0.527208C0.864773 0.189642 1.32261 0 1.8 0H9C9.47739 0 9.93523 0.189642 10.2728 0.527208C10.6104 0.864773 10.8 1.32261 10.8 1.8V7.2H12.6C13.0774 7.2 13.5352 7.38964 13.8728 7.72721C14.2104 8.06477 14.4 8.52261 14.4 9V18.6C14.4 18.7591 14.3368 18.9117 14.2243 19.0243C14.1117 19.1368 13.9591 19.2 13.8 19.2H0.6ZM1.2 1.8V18H3.6V15C3.6 14.8409 3.66321 14.6883 3.77574 14.5757C3.88826 14.4632 4.04087 14.4 4.2 14.4H10.2C10.3591 14.4 10.5117 14.4632 10.6243 14.5757C10.7368 14.6883 10.8 14.8409 10.8 15V18H13.2V9C13.2 8.84087 13.1368 8.68826 13.0243 8.57574C12.9117 8.46321 12.7591 8.4 12.6 8.4H10.2C10.0409 8.4 9.88826 8.33679 9.77574 8.22426C9.66321 8.11174 9.6 7.95913 9.6 7.8V1.8C9.6 1.64087 9.53679 1.48826 9.42426 1.37574C9.31174 1.26321 9.15913 1.2 9 1.2H1.8C1.64087 1.2 1.48826 1.26321 1.37574 1.37574C1.26321 1.48826 1.2 1.64087 1.2 1.8ZM9.6 15.6H7.8V18H9.6V15.6ZM6.6 15.6H4.8V18H6.6V15.6Z"
      fill="#778583"
    />
  </svg>
);

export const DesignationIcon = ({ className }) => (
  <svg
    className={className}
    width="18"
    height="17"
    viewBox="0 0 18 17"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M15.4 5H2.6C1.71634 5 1 5.71634 1 6.6V14.6C1 15.4837 1.71634 16.2 2.6 16.2H15.4C16.2837 16.2 17 15.4837 17 14.6V6.6C17 5.71634 16.2837 5 15.4 5Z"
      stroke="#778583"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M13 5V3C13 2.46957 12.7893 1.96086 12.4142 1.58579C12.0391 1.21071 11.5304 1 11 1H7C6.46957 1 5.96086 1.21071 5.58579 1.58579C5.21071 1.96086 5 2.46957 5 3V5"
      stroke="#778583"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const DateIcon = ({ className }) => (
  <svg
    className={className}
    width="18"
    height="20"
    viewBox="0 0 18 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M14.5625 3H2.5625C1.45793 3 0.5625 3.89543 0.5625 5V17C0.5625 18.1046 1.45793 19 2.5625 19H14.5625C15.6671 19 16.5625 18.1046 16.5625 17V5C16.5625 3.89543 15.6671 3 14.5625 3Z"
      stroke="#778583"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M12.5625 1V5"
      stroke="#778583"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M4.5625 1V5"
      stroke="#778583"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M0.5625 9H16.5625"
      stroke="#778583"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M7.5625 13H8.5625"
      stroke="#778583"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M8.5625 13V16"
      stroke="#778583"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const UsersIcon = ({ className }) => (
  <svg
    className={className}
    width="40"
    height="40"
    viewBox="0 0 40 40"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M28.3307 35V31.6667C28.3307 29.8986 27.6284 28.2029 26.3781 26.9526C25.1279 25.7024 23.4322 25 21.6641 25H8.33073C6.56262 25 4.86693 25.7024 3.61668 26.9526C2.36644 28.2029 1.66406 29.8986 1.66406 31.6667V35"
      stroke="#B8C1BF"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M15.0026 18.3333C18.6845 18.3333 21.6693 15.3486 21.6693 11.6667C21.6693 7.98477 18.6845 5 15.0026 5C11.3207 5 8.33594 7.98477 8.33594 11.6667C8.33594 15.3486 11.3207 18.3333 15.0026 18.3333Z"
      stroke="#B8C1BF"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M38.3359 35.0001V31.6668C38.3348 30.1897 37.8432 28.7548 36.9382 27.5873C36.0332 26.4199 34.7662 25.5861 33.3359 25.2168"
      stroke="#B8C1BF"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M26.6641 5.2168C28.0981 5.58397 29.3691 6.41797 30.2768 7.58731C31.1845 8.75666 31.6771 10.1948 31.6771 11.6751C31.6771 13.1554 31.1845 14.5936 30.2768 15.7629C29.3691 16.9323 28.0981 17.7663 26.6641 18.1335"
      stroke="#B8C1BF"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const FileIcon = ({ className }) => (
  <svg
    className={className}
    width="40"
    height="40"
    viewBox="0 0 40 40"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M24.1641 3.3335H9.9974C9.11334 3.3335 8.26549 3.68469 7.64037 4.30981C7.01525 4.93493 6.66406 5.78277 6.66406 6.66683V33.3335C6.66406 34.2176 7.01525 35.0654 7.64037 35.6905C8.26549 36.3156 9.11334 36.6668 9.9974 36.6668H29.9974C30.8815 36.6668 31.7293 36.3156 32.3544 35.6905C32.9795 35.0654 33.3307 34.2176 33.3307 33.3335V12.5002L24.1641 3.3335Z"
      stroke="#B8C1BF"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M23.3359 3.3335V13.3335H33.3359"
      stroke="#B8C1BF"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M26.6693 21.6665H13.3359"
      stroke="#B8C1BF"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M26.6693 28.3335H13.3359"
      stroke="#B8C1BF"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M16.6693 15H13.3359"
      stroke="#B8C1BF"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const GamepadIcon = ({ className }) => (
  <svg
    className={className}
    width="40"
    height="40"
    viewBox="0 0 40 40"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M10 20H16.6667"
      stroke="#B8C1BF"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M13.3359 16.6665V23.3332"
      stroke="#B8C1BF"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M25 21.6665H25.0167"
      stroke="#B8C1BF"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M30 18.3335H30.0167"
      stroke="#B8C1BF"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M33.3359 10H6.66927C4.82832 10 3.33594 11.4924 3.33594 13.3333V26.6667C3.33594 28.5076 4.82832 30 6.66927 30H33.3359C35.1769 30 36.6693 28.5076 36.6693 26.6667V13.3333C36.6693 11.4924 35.1769 10 33.3359 10Z"
      stroke="#B8C1BF"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const LeftAnchor = ({ className, strokeColor, width, height }) => (
  <svg
    className={className}
    width={width || "8"}
    height={height || "14"}
    viewBox="0 0 8 14"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M7 13L1 7L7 1"
      stroke={strokeColor || "#B8C1BF"}
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const RightAnchor = ({ className, strokeColor, width, height }) => (
  <svg
    className={className}
    width={width || "8"}
    height={height || "14"}
    viewBox="0 0 8 14"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M1 13L7 7L1 1"
      stroke={strokeColor || "#B8C1BF"}
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const ShieldExclamation = ({
  className,
  strokeColor,
  width,
  height,
}) => (
  <svg
    className={className}
    width={width || "16"}
    height={height || "20"}
    viewBox="0 0 17 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M7.83398 15H9.83398V9H7.83398V15ZM8.83398 7C9.11732 7 9.35498 6.904 9.54698 6.712C9.73832 6.52067 9.83398 6.28333 9.83398 6C9.83398 5.71667 9.73832 5.479 9.54698 5.287C9.35498 5.09567 9.11732 5 8.83398 5C8.55065 5 8.31332 5.09567 8.12198 5.287C7.92998 5.479 7.83398 5.71667 7.83398 6C7.83398 6.28333 7.92998 6.52067 8.12198 6.712C8.31332 6.904 8.55065 7 8.83398 7ZM8.83398 20C6.51732 19.4167 4.60498 18.0873 3.09698 16.012C1.58832 13.9373 0.833984 11.6333 0.833984 9.1V3L8.83398 0L16.834 3V9.1C16.834 11.6333 16.08 13.9373 14.572 16.012C13.0633 18.0873 11.1507 19.4167 8.83398 20ZM8.83398 17.9C10.5673 17.35 12.0007 16.25 13.134 14.6C14.2673 12.95 14.834 11.1167 14.834 9.1V4.375L8.83398 2.125L2.83398 4.375V9.1C2.83398 11.1167 3.40065 12.95 4.53398 14.6C5.66732 16.25 7.10065 17.35 8.83398 17.9Z"
      stroke={strokeColor || "#45504D"}
    />
  </svg>
);

export const Calendar = ({ className, strokeColor, width, height }) => (
  <svg
    className={className}
    width={width || "25"}
    height={height || "25"}
    viewBox="0 0 25 25"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M19.167 4.28027H5.16699C4.06242 4.28027 3.16699 5.1757 3.16699 6.28027V20.2803C3.16699 21.3848 4.06242 22.2803 5.16699 22.2803H19.167C20.2716 22.2803 21.167 21.3848 21.167 20.2803V6.28027C21.167 5.1757 20.2716 4.28027 19.167 4.28027Z"
      stroke={strokeColor || "##45504D"}
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M16.167 2.28027V6.28027"
      stroke={strokeColor || "##45504D"}
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M8.16699 2.28027V6.28027"
      stroke={strokeColor || "##45504D"}
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M3.16699 10.2803H21.167"
      stroke={strokeColor || "##45504D"}
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const Copyright = ({ className, strokeColor, width, height }) => (
  <svg
    className={className}
    width={width || "18"}
    height={height || "18"}
    viewBox="0 0 18 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M9 0.875C4.52 0.875 0.875 4.52 0.875 9C0.875 13.48 4.52 17.125 9 17.125C13.48 17.125 17.125 13.48 17.125 9C17.125 4.52 13.48 0.875 9 0.875ZM9 2.125C12.8038 2.125 15.875 5.19625 15.875 9C15.875 12.8038 12.8038 15.875 9 15.875C5.19625 15.875 2.125 12.8038 2.125 9C2.125 5.19625 5.19625 2.125 9 2.125ZM8.94125 5.25C6.86375 5.25 5.19125 6.9225 5.19125 9C5.19125 11.0775 6.86375 12.75 8.94125 12.75C10.4406 12.75 11.7225 11.8512 12.32 10.5819L11.1875 10.055C10.7844 10.9113 9.9425 11.5 8.94125 11.5C7.51813 11.5 6.44125 10.4231 6.44125 9C6.44125 7.57688 7.51813 6.5 8.94125 6.5C9.9425 6.5 10.785 7.08812 11.1875 7.94562L12.3206 7.41813C11.7219 6.14875 10.4406 5.25 8.94063 5.25H8.94125Z"
      stroke={strokeColor || "#45504D"}
    />
  </svg>
);

export const Version = ({ className, strokeColor, width, height }) => (
  <svg
    className={className}
    width={width || "18"}
    height={height || "20"}
    viewBox="0 0 18 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M14.5 2C12.57 2 11 3.57 11 5.5C11 7.054 12.025 8.359 13.43 8.815C13.284 9.747 12.883 10.515 12.2 11.138C10.254 12.911 6.673 13.073 5 13.045V6.837C6.44 6.403 7.5 5.08 7.5 3.5C7.5 1.57 5.93 0 4 0C2.07 0 0.5 1.57 0.5 3.5C0.5 5.08 1.56 6.403 3 6.837V13.163C1.56 13.597 0.5 14.92 0.5 16.5C0.5 18.43 2.07 20 4 20C5.93 20 7.5 18.43 7.5 16.5C7.5 15.949 7.36 15.435 7.133 14.971C9.193 14.785 11.79 14.214 13.542 12.621C14.639 11.624 15.273 10.357 15.446 8.853C16.915 8.438 18 7.1 18 5.5C18 3.57 16.43 2 14.5 2ZM2.5 3.5C2.5 2.673 3.173 2 4 2C4.827 2 5.5 2.673 5.5 3.5C5.5 4.327 4.827 5 4 5C3.173 5 2.5 4.327 2.5 3.5ZM4 18C3.173 18 2.5 17.327 2.5 16.5C2.5005 16.1056 2.65629 15.7273 2.93366 15.4469C3.21103 15.1666 3.58765 15.0067 3.982 15.002L4.112 15.012C4.30819 15.0194 4.50102 15.0653 4.67947 15.1472C4.85791 15.229 5.01849 15.3452 5.15202 15.4892C5.28555 15.6331 5.38942 15.8019 5.45771 15.986C5.52599 16.1701 5.55735 16.3658 5.55 16.562C5.54265 16.7582 5.49672 16.951 5.41485 17.1295C5.33297 17.3079 5.21675 17.4685 5.07282 17.602C4.92889 17.7355 4.76007 17.8394 4.57599 17.9077C4.39192 17.976 4.19619 18.0074 4 18ZM14.5 7C13.673 7 13 6.327 13 5.5C13 4.673 13.673 4 14.5 4C15.327 4 16 4.673 16 5.5C16 6.327 15.327 7 14.5 7Z"
      stroke={strokeColor || "#45504D"}
    />
  </svg>
);

export const ThankYou = ({ className, strokeColor, width, height }) => (
  <svg
    className={className}
    width={width || "138"}
    height={height || "126"}
    viewBox="0 0 138 126"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M44.9127 55.2553C43.8724 54.942 43.2782 53.8427 43.6431 52.8193C45.2993 48.1736 47.8166 43.8748 51.0686 40.1511C54.7526 35.9329 59.2947 32.5498 64.3911 30.228C69.4876 27.9062 75.021 26.6991 80.6215 26.6876C86.2219 26.6761 91.7602 27.8604 96.8662 30.1612C101.972 32.4621 106.528 35.8265 110.229 40.0295C113.931 44.2325 116.692 49.1773 118.329 54.5332C119.966 59.8892 120.44 65.5328 119.72 71.0868C119.085 75.9897 117.532 80.723 115.149 85.0413C114.624 85.9925 113.407 86.2757 112.483 85.7038C111.56 85.132 111.28 83.922 111.799 82.9679C113.891 79.128 115.255 74.9287 115.819 70.5813C116.466 65.5827 116.039 60.5034 114.566 55.6831C113.093 50.8627 110.608 46.4124 107.277 42.6297C103.946 38.847 99.8452 35.819 95.2498 33.7483C90.6544 31.6775 85.6699 30.6117 80.6295 30.622C75.5892 30.6324 70.6091 31.7187 66.0223 33.8084C61.4354 35.898 57.3476 38.9428 54.032 42.7392C51.1484 46.041 48.9067 49.8452 47.4156 53.9555C47.045 54.9768 45.953 55.5685 44.9127 55.2553Z"
      fill="#3FD4A0"
    />
    <path
      d="M62.2617 68.2214L74.5534 80.513L99.1367 55.9297"
      stroke="#3FD4A0"
      strokeWidth="5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M109.946 89.3085C110.796 89.9851 110.94 91.2263 110.222 92.0414C108.214 94.3195 105.95 96.3577 103.474 98.115C102.589 98.7439 101.369 98.4703 100.785 97.5541C100.202 96.6378 100.475 95.4261 101.357 94.7923C103.47 93.275 105.409 91.5297 107.139 89.5878C107.862 88.7766 109.095 88.6319 109.946 89.3085Z"
      fill="#3FD4A0"
    />
    <path
      d="M96.1455 100.066C96.5944 101.056 96.1578 102.227 95.1472 102.626C89.5169 104.848 83.4408 105.745 77.3917 105.234C70.6882 104.667 64.2418 102.392 58.6684 98.624C53.095 94.8563 48.5808 89.7225 45.557 83.713C42.8284 78.2901 41.3957 72.3178 41.3594 66.2649C41.3529 65.1785 42.2767 64.337 43.3621 64.3848C44.4475 64.4325 45.2829 65.3517 45.2954 66.4381C45.3576 71.8182 46.6454 77.1229 49.0716 81.9447C51.793 87.3532 55.8558 91.9736 60.8719 95.3645C65.8879 98.7553 71.6897 100.804 77.7228 101.313C83.1015 101.767 88.5038 100.985 93.5195 99.0374C94.5323 98.6442 95.6966 99.0769 96.1455 100.066Z"
      fill="#3FD4A0"
    />
    <g filter="url(#filter0_f_24768_216583)">
      <path
        d="M133.043 31.5742C133.043 35.5589 129.813 38.7891 125.828 38.7891C121.843 38.7891 118.613 35.5589 118.613 31.5742C118.613 27.5896 121.843 24.3594 125.828 24.3594C129.813 24.3594 133.043 27.5896 133.043 31.5742ZM120.899 31.5742C120.899 34.2968 123.106 36.5038 125.828 36.5038C128.551 36.5038 130.758 34.2968 130.758 31.5742C130.758 28.8517 128.551 26.6446 125.828 26.6446C123.106 26.6446 120.899 28.8517 120.899 31.5742Z"
        fill="#3FD4A0"
      />
    </g>
    <g filter="url(#filter1_f_24768_216583)">
      <path
        d="M14.8245 67.5156L18.5366 74.3037L25.3242 78.0158L18.5366 81.7284L14.8245 88.5156L11.1119 81.7284L4.32422 78.0158L11.1119 74.3037L14.8245 67.5156Z"
        fill="#FF8345"
      />
    </g>
    <g filter="url(#filter2_f_24768_216583)">
      <path
        d="M14.2227 36.5274C14.2227 39.2607 12.0068 41.4766 9.27344 41.4766C6.54006 41.4766 4.32422 39.2607 4.32422 36.5274C4.32422 33.794 6.54006 31.5781 9.27344 31.5781C12.0068 31.5781 14.2227 33.794 14.2227 36.5274ZM5.89185 36.5274C5.89185 38.395 7.40584 39.909 9.27344 39.909C11.141 39.909 12.655 38.395 12.655 36.5274C12.655 34.6598 11.141 33.1458 9.27344 33.1458C7.40584 33.1458 5.89185 34.6598 5.89185 36.5274Z"
        fill="#66B5F8"
      />
    </g>
    <g filter="url(#filter3_f_24768_216583)">
      <path
        d="M58.4096 5.91546C58.6187 4.83547 60.1642 4.83547 60.3732 5.91546L60.6187 7.18352C60.7186 7.69979 61.2013 8.05047 61.7232 7.98596L63.005 7.82751C64.0967 7.69256 64.5743 9.16245 63.6118 9.69497L62.4816 10.3202C62.0215 10.5748 61.837 11.1422 62.0597 11.6186L62.6066 12.7887C63.0723 13.7853 61.8219 14.6937 61.018 13.9429L60.0741 13.0612C59.6898 12.7023 59.0932 12.7023 58.7089 13.0612L57.7649 13.9429C56.961 14.6937 55.7107 13.7853 56.1764 12.7887L56.7233 11.6186C56.9459 11.1422 56.7614 10.5748 56.3013 10.3202L55.1712 9.69497C54.2086 9.16245 54.6863 7.69256 55.778 7.82751L57.0598 7.98596C57.5816 8.05047 58.0643 7.69979 58.1642 7.18352L58.4096 5.91546Z"
        fill="#D9D9D9"
      />
    </g>
    <defs>
      <filter
        id="filter0_f_24768_216583"
        x="114.613"
        y="20.3594"
        width="22.4297"
        height="22.4297"
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity="0" result="BackgroundImageFix" />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="BackgroundImageFix"
          result="shape"
        />
        <feGaussianBlur
          stdDeviation="2"
          result="effect1_foregroundBlur_24768_216583"
        />
      </filter>
      <filter
        id="filter1_f_24768_216583"
        x="0.324219"
        y="63.5156"
        width="29"
        height="29"
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity="0" result="BackgroundImageFix" />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="BackgroundImageFix"
          result="shape"
        />
        <feGaussianBlur
          stdDeviation="2"
          result="effect1_foregroundBlur_24768_216583"
        />
      </filter>
      <filter
        id="filter2_f_24768_216583"
        x="0.324219"
        y="27.5781"
        width="17.8984"
        height="17.8984"
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity="0" result="BackgroundImageFix" />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="BackgroundImageFix"
          result="shape"
        />
        <feGaussianBlur
          stdDeviation="2"
          result="effect1_foregroundBlur_24768_216583"
        />
      </filter>
      <filter
        id="filter3_f_24768_216583"
        x="50.6523"
        y="1.10547"
        width="17.4766"
        height="17.1133"
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity="0" result="BackgroundImageFix" />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="BackgroundImageFix"
          result="shape"
        />
        <feGaussianBlur
          stdDeviation="2"
          result="effect1_foregroundBlur_24768_216583"
        />
      </filter>
    </defs>
  </svg>
);
